import { render } from "./TopTab.vue?vue&type=template&id=2c40133e&scoped=true"
import script from "./TopTab.vue?vue&type=script&lang=js"
export * from "./TopTab.vue?vue&type=script&lang=js"

import "./TopTab.vue?vue&type=style&index=0&id=2c40133e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c40133e"]])

export default __exports__